import { getCookie, removeCookie, setCookie } from 'helpers/VanillaCookie';

const TIMEZONE_COOKIE = 'pplus_timezone';

export function clearTimeZone() {
    removeCookie(TIMEZONE_COOKIE);
}

export function getSavedTimeZone() {
    return getCookie(TIMEZONE_COOKIE);
}

export function getTimeZone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export function saveTimeZone() {
    if (!timeZoneNeedsUpdating()) return;

    const timeZone = getTimeZone();

    setCookie(TIMEZONE_COOKIE, timeZone);

    return timeZone;
}

export function timeZoneNeedsUpdating() {
    const timeZone = getTimeZone();
    const cookieTimeZone = getSavedTimeZone();

    return timeZone !== cookieTimeZone;
}

export function useTimeZone() {
    // Refresh the page to use value server side
    if (timeZoneNeedsUpdating()) {
        saveTimeZone();
    }
}
